    <template>
      <div class="footer">
        <div class="footer-line"></div>
        <div class="container">
            <div class="footer-tab">
<!--              <div>cooperation@MarcoPolo.link</div>-->
<!--              <div class="footer-tab-line"></div>-->
              <div>cooperation@maplabs.io</div>
<!--              <div class="footer-tab-line"></div>-->
<!--              <div>developers@MarcoPolo.link</div>-->
<!--              <div class="footer-tab-line"></div>-->
<!--              <div>developers@maplabs.io</div>-->
            </div>
            <div class="footer-marc">© 2022 Maplabs, All Rights Reseved</div>
        </div>
      </div>
    </template>

    <script>
    export default {
    name: "footer"
    }
    </script>

    <style scoped lang="scss">

    .footer {
      width: 100%;
      padding-bottom: 40px;
    }

    .footer-line {
      margin-top: 46px;
      width: 100%;
      height: 1px;
      background: rgba(0,0,0,0.1);
    }

    .footer-tab {
      padding-top: 40px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: 'poppinsMeduim';
      justify-content: center;
    }

    .footer-tab-line {
        width: 1px;
        height: 12px;
        background-color: #000;
        margin: 0 20px;
    }

    .footer-marc {
      padding-top: 15px;
      font-size: 12px;
      color: rgba(0,0,0,0.35);
      text-align: center;
    }

    </style>
